module.exports = __webpack_public_path__ + "static/seo_image-49d8c89e2a579932a0bd1cb3a077dc84.png";